import React, { useState } from 'react';
import { LogIn, AlertCircle } from "lucide-react";

export const DEFAULT_ACCOUNTS = [
  { id: 'admin', name: '관리자', role: 'admin', pw: '1234' },
];

export const loadAccounts = () => {
  try {
    const stored = localStorage.getItem('gas_accounts');
    return stored ? JSON.parse(stored) : DEFAULT_ACCOUNTS;
  } catch { return DEFAULT_ACCOUNTS; }
};

export const saveAccounts = (accounts) => {
  try { localStorage.setItem('gas_accounts', JSON.stringify(accounts)); } catch {}
  fetch('/api/data/accounts', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(accounts),
  }).catch(e => console.error('[MES] 계정 서버 저장 실패:', e.message));
};

// 서버에서 계정 로드 (서버 우선, 실패 시 localStorage 폴백)
export const loadAccountsFromServer = () =>
  fetch('/api/data')
    .then(r => r.json())
    .then(d => {
      if (d.accounts && d.accounts.length > 0) {
        localStorage.setItem('gas_accounts', JSON.stringify(d.accounts));
        return d.accounts;
      }
      return loadAccounts();
    })
    .catch(() => loadAccounts());

const Login = ({ onLogin }) => {
  const [id, setId]       = useState('');
  const [pw, setPw]       = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const accounts = await loadAccountsFromServer();
      const found = accounts.find(a => a.id === id.trim() && a.pw === pw);
      if (found) {
        onLogin(found);
      } else {
        setError('아이디 또는 비밀번호가 올바르지 않습니다.');
      }
    } catch {
      setError('서버 연결에 실패했습니다. 다시 시도해 주세요.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={bg}>
      <div style={card}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ fontSize: 26, fontWeight: 900, color: '#185FA5', letterSpacing: '-0.5px' }}>DAESUNG ENERGY</div>
          <div style={{ fontSize: 12, color: '#999', marginTop: 5, fontWeight: 500, letterSpacing: 1 }}>MANUFACTURING EXECUTION SYSTEM</div>
          <div style={{ width: 36, height: 3, background: '#185FA5', borderRadius: 2, margin: '14px auto 0' }} />
        </div>

        <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={labelStyle}>아이디</label>
            <input style={inputStyle} placeholder="아이디를 입력하세요" value={id} autoFocus
              onChange={e => { setId(e.target.value); setError(''); }} />
          </div>
          <div>
            <label style={labelStyle}>비밀번호</label>
            <input type="password" style={inputStyle} placeholder="비밀번호를 입력하세요" value={pw}
              onChange={e => { setPw(e.target.value); setError(''); }} />
          </div>

          {error && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 7, padding: '10px 14px', background: '#fef2f2', borderRadius: 8, border: '1px solid #fecaca' }}>
              <AlertCircle size={14} color="#DC2626" />
              <span style={{ fontSize: 13, color: '#DC2626', fontWeight: 600 }}>{error}</span>
            </div>
          )}

          <button type="submit" disabled={loading} style={{ ...loginBtn, opacity: loading ? 0.7 : 1 }}>
            <LogIn size={17} /> {loading ? '확인 중...' : '로그인'}
          </button>
        </form>

        <div style={{ marginTop: 24, padding: '12px 16px', background: '#f8f7f2', borderRadius: 10, fontSize: 12, color: '#999', textAlign: 'center' }}>
          초기 계정: <strong style={{ color: '#555' }}>admin</strong> / <strong style={{ color: '#555' }}>1234</strong>
        </div>
      </div>
    </div>
  );
};

const bg         = { minHeight: '100vh', background: 'linear-gradient(150deg, #0c2d5e 0%, #185FA5 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Pretendard, sans-serif' };
const card       = { background: 'white', borderRadius: 20, padding: '44px 40px', width: 380, boxShadow: '0 24px 64px rgba(0,0,0,0.28)' };
const labelStyle = { display: 'block', fontSize: 13, fontWeight: 600, color: '#555', marginBottom: 6 };
const inputStyle = { width: '100%', padding: '12px 14px', border: '1px solid #d3d1c7', borderRadius: 10, fontSize: 14, boxSizing: 'border-box', background: '#fcfbf7', outline: 'none' };
const loginBtn   = { width: '100%', padding: '13px', background: '#185FA5', color: 'white', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 4 };

export default Login;
